// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"392":"42c70bd2","553":"1ed4133e","645":"1b65a21c","789":"86958733","991":"375ae79c"}[chunkId] + ".chunk.css";
};